import { FullWidthSpace } from "melco-ui";
import { useTranslation } from "react-i18next";
import { ReferencesListAlert } from "../../references/ReferencesListAlert";
import { useFontCollectionReferences } from "../../../hooks/libraries/fontCollections/useFontCollectionReferences";
import { InputFormatReferencesList } from "../../references/InputFormatReferencesList";
import { DataMappingReferencesList } from "../../references/DataMappingReferencesList";

type FontCollectionReferencesListProps = {
  fontCollectionId: string;
};

export const FontCollectionReferencesList: React.FC<
  FontCollectionReferencesListProps
> = ({ fontCollectionId }) => {
  const { t } = useTranslation();

  const { data: fontCollectionReferences } =
    useFontCollectionReferences(fontCollectionId);
  return (
    <FullWidthSpace direction="vertical" size="large">
      <ReferencesListAlert
        message={t("font_collections.actions.references.warning")}
      />

      <DataMappingReferencesList
        dataMappingList={
          fontCollectionReferences?.global_mapping_list ?? undefined
        }
      />

      <InputFormatReferencesList
        inputFormatMappingList={
          fontCollectionReferences?.format_list ?? undefined
        }
      />
    </FullWidthSpace>
  );
};
